import { createFileRoute } from '@tanstack/react-router';
import { DashboardFacturacionPage } from '@/components/DashboardFacturacionPage';

export const Route = createFileRoute('/_authenticated/dashboard/facturacion')({
  component: DashboardFacturacionPage,
});
